import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import axios from "../../API/axios";
import ApplyjobAsCandidate from "../Searchjob/ApplyjobAsCandidate";
import ApplyjobAsInstitute from "../Searchjob/ApplyjobAsInstitute";
import NotFound from "../NotFound";
import moment from "moment";
import Default_user_image from "../../assets/images/Default_user_image.png"
import toast from "react-hot-toast";


const JobDetails = () => {
    const { JobId } = useParams();
    const token = localStorage.getItem('token')
    const userUID = localStorage.getItem("userUID");
    const userType = localStorage.getItem("userType");
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState([]);
    const [candidateDataUpdated, setCandidateDataUpdated] = useState(null);
    const progressRef = useRef();
    const [isError, setIsError] = useState(false);
    const [nextBatchLoading, setNextBatchLoading] = useState("");
    const [targetHeight, setTargetHeight] = useState(0);
    const [toggle, setToggle] = useState({
        key: "",
        status: false,
    });
    const [isShowMobile, setShowMobile] = useState(false);


    useEffect(() => {
        if (progressRef?.current) {
            const offsetHeight = progressRef?.current?.offsetTop;
            setTargetHeight(offsetHeight);
        }
    }, [progressRef]);
    const [jobList, setjobList] = useState([]);
    console.log('jobList', jobList);

    // const [currentPage, setCurrentPage] = useState(1);
    const [jobData, setJobData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [instituteAppliedJobsInfo, setInstituteAppliedJobInfo] = useState("")
    console.log("jobData", jobData);

    // ...............................All Job List.......................................

    // ...............................All Jobs List.......................................

    useEffect(() => {
        getJobDetail();
    }, [JobId]);

    const getJobDetail = () => {
        setIsLoading(true)
        axios
            .get(`/Job/GetJobDetails?JobId=${JobId}`)
            .then((response) => {
                if (response.status === 204) {
                    setJobData(null);
                } else {
                    setJobData(response.data.responseData);
                }
                setInstituteAppliedJobInfo(response.data.responseData.instituteAppliedJobsInfo)
                setIsLoading(false)
            })
            .catch((error) => {
                setJobData(null);
                toast.error(error?.response?.data?.message);
                console.error("Error:", error);
            })
            .finally(() => setIsLoading(false));
    };

    if (isLoading)
        return <div className="mt-6 d-flex justify-content-center">
            <p>Loading...</p>
        </div>;

    if (!jobData) {
        return <NotFound />;
    }

    // const addTargetBlankToAnchors = (html) => {
    //     const div = document.createElement('div');
    //     div.innerHTML = html;

    //     const anchors = div.querySelectorAll('a');
    //     anchors.forEach(anchor => {
    //         anchor.setAttribute('target', '_blank');
    //         anchor.setAttribute('rel', 'noopener noreferrer');
    //     });

    //     return div.innerHTML;
    // };

    const addTargetBlankToAnchors = (html) => {
        if (!html) return ''; // Ensure we don't process null values

        const div = document.createElement('div');
        div.innerHTML = html;

        // Select only <a> tags and modify them
        const anchors = div.querySelectorAll('a');
        anchors.forEach(anchor => {
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('rel', 'noopener noreferrer');
        });

        return div.innerHTML; // Return cleaned HTML
    };

    const linkifyContent = (htmlContent) => {
        const urlPattern = /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
        return htmlContent.replace(urlPattern, function (url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        });
    };


    // ..............................................................

    // Money Format at Code Language Start
    // const formatSalary = (salary) => {
    // 	if (salary >= 10000000) {
    // 		return (salary / 10000000).toFixed(1) + 'Cr'; // 'Cr' for crore
    // 	} else if (salary >= 1000000) {
    // 		return (salary / 1000000).toFixed(1) + 'M'; // 'M' for million
    // 	} else if (salary >= 100000) {
    // 		return (salary / 100000).toFixed(1) + 'L'; // 'L' for lakh
    // 	} else if (salary >= 1000) {
    // 		return (salary / 1000).toFixed(1) + 'k'; // 'k' for thousand
    // 	} else {
    // 		// For salaries less than 1000
    // 		return salary;
    // 	}
    // }
    const formatSalary = (salary) => {
        if (salary >= 10000000) {
            return (salary / 10000000).toFixed(1) + 'Cr'; // 'Cr' for crore
        } else if (salary >= 100000) {
            return (salary / 100000).toFixed(1) + 'L'; // 'L' for lakh (includes 10L for 1M)
        } else if (salary >= 1000) {
            return (salary / 1000).toFixed(1) + 'k'; // 'k' for thousand
        } else {
            return salary; // Return as is for values less than 1000
        }
    };

    return (
        <>
            {/* <section className="single-job-thumb">
                <img
                    src={require("../../assets/images/khoj-images/singlejob.f19680c90ccac510942d.jpg")}
                    alt="images"
                />
            </section> */}

            <section className=" fixed-space">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="wd-job-author2 Job-Details-Content">
                                <div className="content-left col-lg-8">
                                    <div className="thumb">
                                        <img
                                            src={jobData?.compImage}
                                            // src={Default_user_image}
                                            alt="logo"
                                            width={"100px"} style={{ borderRadius: "50%", height: "100px" }}
                                        />
                                    </div>
                                    <div className="content">

                                        {
                                            jobData.compType === "Company" ? (
                                                <Link className="category" to={`/Company/${jobData.compUid}`}>{jobData.compName}</Link>
                                            ) : (
                                                <>
                                                    <Link className="category" to={`/Recruiter/${jobData.compUid}`}>{jobData.compName}</Link>
                                                    {/* <span className="rec-badge-purple ms-2">{jobData.compType}</span> */}
                                                </>

                                            )
                                        }
                                        <h6>
                                            <Link style={{ pointerEvents: "none" }} to="javascript:void(0);">{jobData?.title}</Link>
                                        </h6>
                                        <ul className="job-info ps-0 ">
                                            {jobData.creationTime === null ? '' : (
                                                <li>
                                                    <span className="icon-map-pin"></span>
                                                    <span>{jobData?.cityName}</span>
                                                </li>
                                            )}
                                            {jobData.creationTime === null ? '' :
                                                <>
                                                    <li>
                                                        <span className="icon-calendar me-1"></span>
                                                        &nbsp;
                                                        {/* {moment.utc(jobData.creationTime).local().format("DD MMMM YYYY")} */}
                                                        {moment.utc(jobData.creationTime).local().format("DD MMM YYYY")}
                                                    </li>
                                                </>
                                            }
                                        </ul>
                                        <ul className="tags ps-0 job-info-tag-li">
                                            {jobData?.jbTypName === null || jobData?.jbTypName === "" ? '' : (
                                                <li>
                                                    <Link to="" style={{ pointerEvents: "none" }}
                                                        onClick={(e) => e.preventDefault()}
                                                    >{jobData?.jbTypName}</Link>
                                                </li>
                                            )}
                                            {jobData?.workLevelTypename === null || jobData?.workLevelTypename === "" ? '' : (
                                                <li>
                                                    <Link to="" style={{ pointerEvents: "none" }}
                                                        onClick={(e) => e.preventDefault()}
                                                    >{jobData?.workLevelTypename}</Link>
                                                </li>
                                            )}
                                            {jobData?.workLocationTypeName === null || jobData?.workLocationTypeName === "" ? '' : (
                                                <li>
                                                    <Link to="" style={{ pointerEvents: "none" }}
                                                        onClick={(e) => e.preventDefault()}
                                                    >{jobData?.workLocationTypeName}</Link>
                                                </li>
                                            )}
                                            {jobData?.designationName === null || jobData?.designationName === "" ? '' : (
                                                <li>
                                                    <Link to="" style={{ pointerEvents: "none" }}
                                                        onClick={(e) => e.preventDefault()}
                                                    >{jobData?.designationName}</Link>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>

                                <div className="content-right col-lg-3">
                                    <div className="top text-end applybtn-mainbtn mb-0">
                                        {userType === "Candidate" ? (
                                            <ApplyjobAsCandidate
                                                jobId={jobData?.jobId}
                                                status={jobData?.status}
                                                isAppliedByYou={jobData?.isApplied}
                                                setCandidateDataUpdated={setCandidateDataUpdated}
                                            />
                                        ) : userType === "Institution" ? (
                                            // <ApplyjobAsCandidate jobId={jobData?.jobId} isAppliedByYou={jobData?.isApplied} />
                                            <ApplyjobAsInstitute
                                                jobId={jobData?.jobId}
                                                status={jobData?.status}
                                                isAppliedByYou={jobData?.isApplied}
                                                instituteAppliedJobsInfo={instituteAppliedJobsInfo}
                                                getJobDetail={getJobDetail}
                                            />
                                        ) : ""}
                                    </div>
                                    <div className="bottom">
                                        <div className="gr-rating">
                                            {/* <p>32 days left to apply</p> */}
                                        </div>
                                        <div className="price ">
                                            <p className="mb-0 ms-2">
                                                <span className="me-2">{jobData?.currency.toUpperCase()}</span>
                                                {(jobData.minSalary)} - {(jobData?.maxSalary)}
                                                <span className="year">
                                                    <br />
                                                    {jobData?.salaryTypeName}</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="container mt-3">
                <section className="inner-jobs-section">
                    <div className="tf-container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Tabs className="job-article tf-tab single-job">
                                    <TabList className="menu-tab p-0">
                                        <Tab className="ct-tab">Description</Tab>
                                        <Tab className="ct-tab"> Requirement</Tab>
                                        {/* <Tab className="ct-tab">reviews</Tab> */}
                                    </TabList>
                                    <div className="content-tab">
                                        <TabPanel className="inner-content animation-tab">
                                            {jobData?.description === null ? '' : (
                                                <>
                                                    {/* {jobData.description.split("\n").map((line, index) => (
                                                        <p key={index}>{line}</p>
                                                    ))} */}
                                                    <div className="f-14 p-2 postContent">
                                                        <div
                                                            className='postrequrement'
                                                            // dangerouslySetInnerHTML={{
                                                            //     __html: linkifyContent(
                                                            //         addTargetBlankToAnchors(jobData.description)
                                                            //     )
                                                            // }}
                                                            dangerouslySetInnerHTML={{ __html: addTargetBlankToAnchors(jobData.description) }}
                                                        />

                                                    </div>
                                                </>
                                            )}



                                        </TabPanel>
                                        <TabPanel className="inner-content inner-content-requirement animation-tab">
                                            {/* {jobData?.requirement ? (
                                                <ul className="custom-bullet-list"> */}
                                            {/* {jobData.requirement.split("\n").map((line, index) => {
                                                        // Trim spaces and ensure bullet has space after it
                                                        const formattedLine = line.replace(/•/g, "•    "); // Add space after bullet

                                                        return <p key={index}>{formattedLine}</p>;
                                                    })} */}
                                            {/* </ul>
                                            ) : null} */}
                                            {/* {jobData.requirement} */}
                                            <div className="f-14 p-2 postContent">
                                                <div
                                                    className='postrequrement'
                                                    // dangerouslySetInnerHTML={{
                                                    //     __html: linkifyContent(
                                                    //         addTargetBlankToAnchors(jobData.requirement)
                                                    //     )
                                                    // }}
                                                    dangerouslySetInnerHTML={{ __html: addTargetBlankToAnchors(jobData.requirement) }}
                                                // dangerouslySetInnerHTML={{ __html: jobData.requirement }}
                                                // dangerouslySetInnerHTML={{ __html: jobData.requirement }}
                                                />


                                            </div>

                                        </TabPanel>


                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default JobDetails;
